import * as React from 'react'
import { css, cx } from '@emotion/css'
import { FlowMapColumnTitle } from '../../column-title'
import {
  AppAggregationCategory,
  columnMarginTop,
  connectedAppsColumnWidth,
  getColumnContainerStyle
} from '../../index'
import { ColumnHeader } from '../../../../legacy-design-system/grid/column-header'
import { metadataHeaderRenderer } from '../../../applications-grid/metadata-header'
import { ColumnHeaderFilters } from '../../../../legacy-design-system/grid'
import {
  CustomApplicationAggregation,
  MetadataFilter
} from '../../../applications-grid'

export interface Props {
  readonly filters: ColumnHeaderFilters<AppAggregationCategory> | undefined
  readonly metadataAggregations: CustomApplicationAggregation[]
  readonly customMetadataSelections: MetadataFilter[]
  readonly onMetadataOptionsToggle: (
    groupID: string,
    optionIDs: string[]
  ) => void
  readonly onClearMetadataSelections: () => void
  readonly appAggregations: AppAggregationCategory[]
  readonly getOnAllAggregationCategoriesClear: (
    categories: AppAggregationCategory[]
  ) => void
}

export class ConnectedAppsColumn extends React.Component<Props> {
  public render() {
    const {
      filters,
      getOnAllAggregationCategoriesClear,
      appAggregations,
      metadataAggregations,
      customMetadataSelections,
      onMetadataOptionsToggle,
      onClearMetadataSelections
    } = this.props

    return (
      <div
        className={cx(
          getColumnContainerStyle(connectedAppsColumnWidth, columnMarginTop),
          css`
            cursor: default;
          `
        )}
      >
        <div
          className={css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding-left: 25px;
          `}
        >
          <FlowMapColumnTitle
            titleI18n={'title_applicationFlowMap_connectedApplications'}
            position={'flex-start'}
          />
          {filters && (
            <div
              className={css`
                height: fit-content;
                width: fit-content;
                margin: -3px;
              `}
            >
              <ColumnHeader
                clearAll={() =>
                  getOnAllAggregationCategoriesClear(appAggregations)
                }
                filters={filters}
                isDrilldown={true}
                aggregations={appAggregations}
                render={(props) =>
                  metadataHeaderRenderer({
                    ...props,
                    customAggregations: metadataAggregations,
                    customAggregationSelections: customMetadataSelections,
                    onMetadataOptionsToggle,
                    onClearMetadataSelections
                  })
                }
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}
